var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDirectedArrows(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 272,
    height: 19,
    viewBox: "0 0 272 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M266.036 0.5H271.821L265.393 9.5L271.821 18.5H266.036L259.607 9.5L266.036 0.5Z",
    fill: "url(#paint0_linear_178_1907)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M249.821 0.5H255.607L249.178 9.5L255.607 18.5H249.821L243.393 9.5L249.821 0.5Z",
    fill: "url(#paint1_linear_178_1907)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M233.607 0.5H239.393L232.964 9.5L239.393 18.5H233.607L227.178 9.5L233.607 0.5Z",
    fill: "url(#paint2_linear_178_1907)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M217.393 0.5H223.178L216.75 9.5L223.178 18.5H217.393L210.964 9.5L217.393 0.5Z",
    fill: "url(#paint3_linear_178_1907)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M201.179 0.5H206.964L200.536 9.5L206.964 18.5H201.179L194.75 9.5L201.179 0.5Z",
    fill: "url(#paint4_linear_178_1907)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M184.964 0.5H190.75L184.321 9.5L190.75 18.5H184.964L178.536 9.5L184.964 0.5Z",
    fill: "url(#paint5_linear_178_1907)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M168.75 0.5H174.536L168.107 9.5L174.536 18.5H168.75L162.321 9.5L168.75 0.5Z",
    fill: "url(#paint6_linear_178_1907)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M152.536 0.5H158.321L151.893 9.5L158.321 18.5H152.536L146.107 9.5L152.536 0.5Z",
    fill: "url(#paint7_linear_178_1907)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M136.321 0.5H142.107L135.678 9.5L142.107 18.5H136.321L129.893 9.5L136.321 0.5Z",
    fill: "url(#paint8_linear_178_1907)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M120.107 0.5H125.893L119.464 9.5L125.893 18.5H120.107L113.678 9.5L120.107 0.5Z",
    fill: "url(#paint9_linear_178_1907)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M103.893 0.5H109.678L103.25 9.5L109.678 18.5H103.893L97.4639 9.5L103.893 0.5Z",
    fill: "url(#paint10_linear_178_1907)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M87.6782 0.5H93.4639L87.0353 9.5L93.4639 18.5H87.6782L81.2496 9.5L87.6782 0.5Z",
    fill: "url(#paint11_linear_178_1907)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M71.4643 0.5H77.25L70.8214 9.5L77.25 18.5H71.4643L65.0357 9.5L71.4643 0.5Z",
    fill: "url(#paint12_linear_178_1907)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2499 0.5H61.0356L54.6071 9.5L61.0356 18.5H55.2499L48.8214 9.5L55.2499 0.5Z",
    fill: "url(#paint13_linear_178_1907)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0356 0.5H44.8213L38.3927 9.5L44.8213 18.5H39.0356L32.607 9.5L39.0356 0.5Z",
    fill: "url(#paint14_linear_178_1907)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8212 0.5H28.6069L22.1784 9.5L28.6069 18.5H22.8212L16.3926 9.5L22.8212 0.5Z",
    fill: "url(#paint15_linear_178_1907)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M6.60686 0.5H12.3926L5.96401 9.5L12.3926 18.5H6.60686L0.178292 9.5L6.60686 0.5Z",
    fill: "url(#paint16_linear_178_1907)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_178_1907",
    x1: 271.821,
    y1: 9.5,
    x2: 259.607,
    y2: 9.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#02A9BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01828D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_178_1907",
    x1: 255.607,
    y1: 9.5,
    x2: 243.393,
    y2: 9.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#02A9BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01828D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_178_1907",
    x1: 239.393,
    y1: 9.5,
    x2: 227.178,
    y2: 9.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#02A9BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01828D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_178_1907",
    x1: 223.178,
    y1: 9.5,
    x2: 210.964,
    y2: 9.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#02A9BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01828D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_178_1907",
    x1: 206.964,
    y1: 9.5,
    x2: 194.75,
    y2: 9.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#02A9BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01828D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_178_1907",
    x1: 190.75,
    y1: 9.5,
    x2: 178.536,
    y2: 9.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#02A9BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01828D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_178_1907",
    x1: 174.536,
    y1: 9.5,
    x2: 162.321,
    y2: 9.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#02A9BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01828D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_178_1907",
    x1: 158.321,
    y1: 9.5,
    x2: 146.107,
    y2: 9.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#02A9BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01828D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_178_1907",
    x1: 142.107,
    y1: 9.5,
    x2: 129.893,
    y2: 9.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#02A9BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01828D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_178_1907",
    x1: 125.893,
    y1: 9.5,
    x2: 113.678,
    y2: 9.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#02A9BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01828D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_178_1907",
    x1: 109.678,
    y1: 9.5,
    x2: 97.4639,
    y2: 9.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#02A9BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01828D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_178_1907",
    x1: 93.4639,
    y1: 9.5,
    x2: 81.2496,
    y2: 9.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#02A9BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01828D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_178_1907",
    x1: 77.25,
    y1: 9.5,
    x2: 65.0357,
    y2: 9.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#02A9BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01828D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_178_1907",
    x1: 61.0356,
    y1: 9.5,
    x2: 48.8214,
    y2: 9.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#02A9BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01828D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_178_1907",
    x1: 44.8213,
    y1: 9.5,
    x2: 32.607,
    y2: 9.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#02A9BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01828D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_178_1907",
    x1: 28.6069,
    y1: 9.5,
    x2: 16.3926,
    y2: 9.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#02A9BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01828D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_178_1907",
    x1: 12.3926,
    y1: 9.5,
    x2: 0.178292,
    y2: 9.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#02A9BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01828D"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirectedArrows);
export default __webpack_public_path__ + "static/media/directed-arrows.bf0eeec691ab132cc00ca16a9690ced6.svg";
export { ForwardRef as ReactComponent };